import React, { Component } from "react";
import Spinner from "./Common/Spinner";
import "./Common/Common.css";
import Input from "./2/Controls/Input";
import Window from "./2/Controls/Window";
import DashboardCtrl from "./Reports/DashboardCtrl";
import "./2/style.css";
import { isMobileApp } from "../actions/Util";
import { saveFcmTokenData } from "../CommonFunctions";

class Home extends Component {
  constructor() {
    super();
    this.state = {
      selectedStore: null,
      helpVideos: "",
      stores: [],
      loading: false,
      storeSearchText: "",
      title: "",
      appBannerItems: [],
      showDashboard: false,
      menuURL: "",
      menuURLData: null,
      expiryMessage: "",
      showNoticePopup: true,
    };
    this.onStoreSelection = this.onStoreSelection.bind(this);
    this.onClickRedirect = this.onClickRedirect.bind(this);
    this.getCountryConfig = this.getCountryConfig.bind(this);
    this.renderDesktopStoreSelection = this.renderDesktopStoreSelection.bind(
      this
    );
    this.renderHome = this.renderHome.bind(this);
    this.renderAccountExpiringMsg = this.renderAccountExpiringMsg.bind(this);
    this.preloadImages = this.preloadImages.bind(this);
  }

  componentDidMount() {
    if (!this.props.user.store) {
      this.props
        .getUserStores(
          this.props.user.user.RegistrationID,
          this.props.user.auth.uid
        )
        .then((stores) => {
          // console.log("stores", stores);
          if (stores.length === 1) {
            this.onStoreSelection(stores[0]);
          } else {
            this.props.setHasAccessToMultipleStores(true);
            this.setState({ stores: stores, title: "Store Selection" });
          }
        });
    }

    let showDashboard = false;
    if (
      this.props.user.store &&
      this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
      this.props.user.store.NoOfDaysToExpire > 0 &&
      this.props.user.user.Role !== "Store Cashier" &&
      this.getVisibility("Reports", "read")
    ) {
      if (this.showModule("Sales Dashboard", false)) {
        showDashboard = true;
      }
    }
    this.setState({ showDashboard: showDashboard });
  }

  async onStoreSelection(store) {
    if (!store) {
      return;
    }
    this.setState({ loading: true });
    this.setState({ value: "Populating configuration!!!" });
    store.Currency = "₹";
    await this.props.setStore(store);
    console.log("this.props.user",this.props.user.user);
    await saveFcmTokenData(store,this.props.user.user);
    await this.props.getUserACL(this.props.user.auth.uid);
    await this.props.getTransactionTypes(this.props.user.user.RegistrationID);
    this.preloadImages();
    this.props
      .getStoresList( 0, 1000)
      .then((result) => {
        this.props.setStores(result.stores);
      });
    await this.props.getAllProductCategoriesToRedux();
    await this.props.getAllProductSubCategoriesToRedux();
    this.props.getReportConfigs();
    this.props.getWhatsappActiveProvider(this.props.user.user.RegistrationID);
    this.props.getProductBrands();
    this.props.getProductTaxes(this.props.user.user.RegistrationID);
    this.props.getPaymentTypes(this.props.user.user.RegistrationID);
    this.props.getAllCustomFieldNames(this.props.user.user.RegistrationID);
    this.props.getPrintConfigs(this.props.user.user.RegistrationID, store.key);
    this.props.getSalesChannel(this.props.user.user.RegistrationID);
    this.props.getProductTags(this.props.user.user.RegistrationID);
    this.props.getActiveModifiers(this.props.user.user.RegistrationID); //pawan
    this.props.getApplicableOffers(this.props.user.user.RegistrationID);
    this.props.getActiveEmployees(store.key);
    this.props.getActiveMemberships(this.props.user.user.RegistrationID);
    await this.loadProducts(store);
    this.getCountryConfig();
    this.setState({ loading: false, title: "" });
    if (
      this.props.user.store &&
      this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
      this.props.user.store.NoOfDaysToExpire > 0 &&
      this.props.user.user.Role !== "Store Cashier" &&
      this.getVisibility("Reports", "read")
    ) {
      if (this.showModule("Sales Dashboard", false)) {
        this.setState({ showDashboard: true });
      }
    }
    this.renderAccountExpiringMsg();
  }

  async preloadImages() {
    let printList = await this.props.getPrintConfigsList(
      this.props.registration.registration.key,
      this.props.user.store.key
    );
    printList.map((t) => {
      if (t.HeaderImage) {
        const img = new Image();
        img.src = t.HeaderImage.Preview;
      }
    });
  }

  async loadProducts(store) {

    if (!this.props.registration.registration.OnlineBilling) {
      this.setState({ value: "Populating Products!!!" });
      const storeID = store.key;
      let from = 0;
      const size = 2000; // batch size
      let products = [];
      let totalCount = 0;
      do {
      const result = await this.props.getProducts(
  from,
  size,
  "active"
);
        let apiProducts = result.products;
        totalCount = result.totalCount;
        apiProducts.forEach((product) => {
          product.ActionOn = null;
          let checkForateSpecificPriceOptions = true;
          // 🔹 Variant product
          if (
            product.hasOwnProperty("ParentProductID") &&
            product.ParentProductID !== ""
          ) {
            checkForateSpecificPriceOptions = false;
          }

          // 🔹 AccessibleToSelectedStores logic
          if (
            product.hasOwnProperty("AccessibleToSelectedStores") &&
            product.AccessibleToSelectedStores &&
            checkForateSpecificPriceOptions
          ) {
            const storePrice = product.StoreSpecificPrices.filter(
              (f) => f.StoreID === storeID
            );
            if (storePrice.length > 0) {
              const sp = storePrice[0];
              Object.assign(product, {
                RetailPrice: sp.RetailPrice,
                SupplyPrice: sp.SupplyPrice,
                Markup: sp.Markup,
                DiscountAmount: sp.DiscountAmount || 0,
                DiscountPercentage: sp.DiscountPercentage || 0,
                MRP: sp.MRP,
                WalletTopUpSameAsRetailPrice:
                  sp.WalletTopUpSameAsRetailPrice || false,
                WalletTopUpAmount: sp.WalletTopUpAmount || 0,
                EditWalletTopUpAmount: sp.EditWalletTopUpAmount || false,
                key: product.key,
              });
              products.push(product);
            }
            // 🔹 StoreSpecificPricing logic
          } else if (
            product.hasOwnProperty("StoreSpecificPricing") &&
            product.StoreSpecificPricing &&
            checkForateSpecificPriceOptions
          ) {
            const storePrice = product.StoreSpecificPrices.filter(
              (f) => f.StoreID === storeID
            );
            if (storePrice.length > 0) {
              const sp = storePrice[0];
              Object.assign(product, {
                RetailPrice: sp.RetailPrice,
                SupplyPrice: sp.SupplyPrice,
                Markup: sp.Markup,
                DiscountAmount: sp.DiscountAmount || 0,
                DiscountPercentage: sp.DiscountPercentage || 0,
                MRP: sp.MRP,
                WalletTopUpSameAsRetailPrice:
                  sp.WalletTopUpSameAsRetailPrice || false,
                WalletTopUpAmount: sp.WalletTopUpAmount || 0,
                EditWalletTopUpAmount: sp.EditWalletTopUpAmount || false,
                key: product.key,
              });
              products.push(product);
            } else {
              products.push(product);
            }
          } else {
            products.push(product);
          }
        });
        from += size;
      } while (from < totalCount);
      console.log("products", products);
      await this.props.pushProductsToRedux(products);
      await this.props.poupulateSaleCategories();
      await this.props.poupulateSaleSubCategories();
    }
  }

  renderAccountExpiringMsg() {
    let message = "";
    if (this.props.user.store.NoOfDaysToExpire <= 0) {
      if (Math.abs(this.props.user.store.NoOfDaysToExpire) === 0) {
        message =
          "Your " +
          this.props.config.WhiteLabel.Title +
          " subscription has expired. Kindly renew to enjoy uninterrupted services.";
      } else {
        message =
          "Your " +
          this.props.config.WhiteLabel.Title +
          " subscription has expired " +
          Math.abs(this.props.user.store.NoOfDaysToExpire) +
          " day(s) back. Kindly renew to enjoy uninterrupted services.";
      }
    } else if (
      this.props.user.store.NoOfDaysToExpire > 0 &&
      this.props.user.store.NoOfDaysToExpire <= 30
    ) {
      if (Math.abs(this.props.user.store.NoOfDaysToExpire) === 0) {
        message =
          "Your " +
          this.props.config.WhiteLabel.Title +
          " subscription will expire today. Kindly renew to enjoy uninterrupted services.";
      } else {
        message =
          "Your " +
          this.props.config.WhiteLabel.Title +
          " subscription will expire in " +
          Math.abs(this.props.user.store.NoOfDaysToExpire) +
          " day(s). Kindly renew to enjoy uninterrupted services.";
      }
    }
    this.setState({ expiryMessage: message });
  }

  getCountryConfig() {
    let countryCode = "IN";
    let country = "India";
    let currencySymbol = "₹";
    let currency = "INR";
    let currencyDenominations = [];
    if (
      this.props.registration.registration.Country !== "" &&
      this.props.registration.registration.Country !== "India"
    ) {
      let countries = this.props.getCountries();
      let countriesTmp = countries.filter(
        (f) =>
          f.Name.toLowerCase().trim() ===
          this.props.registration.registration.Country.toLowerCase().trim()
      );
      if (countriesTmp.length > 0) {
        countryCode = countriesTmp[0].Code;
        country = countriesTmp[0].Name;
        currency = countriesTmp[0].Currency;
        currencySymbol = countriesTmp[0].CurrencySymbol;
      }
    }
    let currencyDemoTmp = this.props.getCurrencyDenominations();
    if (currencyDemoTmp.filter((f) => f.Currency === currency).length > 0) {
      currencyDenominations = currencyDemoTmp.filter(
        (f) => f.Currency === currency
      )[0].Denominations;
    }
    this.props.updateCountryConfig({
      CountryCode: countryCode,
      Country: country,
      CurrencySymbol: currencySymbol,
      CurrencyDenominations: currencyDenominations,
    });
  }

  onClickRedirect(redirectionLink, state = null) {
    if (state)
      this.props.history.push({ pathname: redirectionLink, state: state });
    else this.props.history.push({ pathname: redirectionLink });
  }

  renderDesktopStoreSelection() {
    return (
      <React.Fragment>
        <Window
          header={"Store selection"}
          height={"500px"}
          modal={false}
          hideClose={true}
          processing={this.state.processing}
          onButtonClick={this.onValidatePinCode}
          buttons={[]}
        >
          <Input
            type="search"
            placeholder="Search store"
            value={this.state.storeSearchText}
            onChange={(value) => this.setState({ storeSearchText: value })}
          />
          <div
            // className="store-selection-list"
            style={{
              height: isMobileApp() ? window.innerHeight - 140 + "px" : "400px",
              overflowY: "auto",
            }}
          >
            {this.state.stores
              .filter((f) => {
                let storeSearchText = this.state.storeSearchText;
                if (storeSearchText === 0) {
                  return true;
                } else {
                  if (
                    f.StoreCode.toLowerCase().includes(
                      storeSearchText.toLowerCase()
                    ) ||
                    f.StoreName.toLowerCase().includes(
                      storeSearchText.toLowerCase()
                    ) ||
                    f.Address1.toLowerCase().includes(
                      storeSearchText.toLowerCase()
                    ) ||
                    f.Address2.toLowerCase().includes(
                      storeSearchText.toLowerCase()
                    ) ||
                    f.City.toLowerCase().includes(
                      storeSearchText.toLowerCase()
                    ) ||
                    f.State.toLowerCase().includes(
                      storeSearchText.toLowerCase()
                    ) ||
                    f.Country.toLowerCase().includes(
                      storeSearchText.toLowerCase()
                    )
                  ) {
                    return true;
                  }
                }
                return false;
              })
              .map((store, index) => (
                <React.Fragment key={"store1" + index}>
                  <div
                    key={"store" + index}
                    className="list-row"
                    onClick={() => {
                      this.setState({ title: "" });
                      this.onStoreSelection(store);
                    }}
                  >
                    <div>
                      <div className="row-title">
                        {store.StoreCode + " - " + store.StoreName}
                      </div>
                      <div className="row-sub-text">{store.Address1}</div>
                      <div className="row-sub-text">{store.Address2}</div>
                      <div className="row-sub-text">{store.City}</div>
                      <div className="row-sub-text">{store.State}</div>
                      <div className="row-sub-text">{store.Country}</div>
                    </div>
                  </div>
                  <div key={"sep" + index} className="seperator"></div>
                </React.Fragment>
              ))}
          </div>
        </Window>
      </React.Fragment>
    );
  }

  showModule(module, forRole) {
    if (forRole) {
      if (
        this.props.user.user.hasOwnProperty("RoleKey") &&
        this.props.user.user.RoleKey !== ""
      ) {
        return this.props.getVisibility(module, "read");
      } else {
        return true;
      }
    } else {
      return this.getVisibility(module, "read");
    }
  }

  getVisibility(module, access) {
    let response = this.props.getVisibility(module, access);
    if (response === "inline") {
      return true;
    } else {
      //: "none"
      return false;
    }
  }

  renderHome() {
    return (
      <React.Fragment>
         {(this.props.user.store && this.state.expiryMessage !== "") && (
                <div className="account-expiring">
                  {this.state.expiryMessage}
                </div>
              )}
        <div className="content-wrapper">
          {this.props.user.store && (
            <div>
             

         

              <section className="content">
                {this.state.showDashboard && <DashboardCtrl expiryMessage={this.state.expiryMessage} {...this.props} />}

                {!this.state.showDashboard && (
                  <div style={{ fontSize: "20px" }}>
                    Welcome to {this.props.config.WhiteLabel.Title}
                  </div>
                )}
              </section>
            </div>
          )}

          {this.state.loading && <Spinner />}

          {!this.props.user.store &&
            this.state.stores &&
            this.state.stores.length > 0 &&
            this.renderDesktopStoreSelection()}
        </div>
      </React.Fragment>
    );
  }

  render() {
    return <React.Fragment>{this.renderHome()}</React.Fragment>;
  }
}

export default Home;
